import React from "react"
import TaskDynamicFormTypes from "src/pages/dynamic_forms/Types/TaskDynamicFormTypes"
import DynamicFormsCustomRadio from "src/pages/dynamic_forms/Utils/CustomRadio/DynamicFormsCustomRadio"
import taskHelper from "../../taskHelper"
import "./TaskDynamicFormOptionsPoint.css"

interface Props {
    manageParentState: Function
    taskBoiler: TaskDynamicFormTypes
    DistributionPoints: Array<{
        PortalDynamicFormDistributionPointId: number,
        Name: string
    }>
}

function TaskDynamicFormOptionsPoint(props: Props) {

    // console.log("TaskDynamicFormOptionsPoint props", props)

    return (
        <div className="TaskDynamicFormOptionsPoint">
            {props.DistributionPoints.map((point, i: number) =>
                <div className="TaskDynamicFormOptionsPointItem" key={`task-dynamic-form-options-group-item-${i}`}>
                    <DynamicFormsCustomRadio
                        title={taskHelper.getPointAlias(point.Name)}
                        checked={props.taskBoiler.DistributionPoint === point.Name}
                        callback={() => {
                            let temp = props.taskBoiler
                            temp.DistributionPoint = point.Name
                            temp.PortalDynamicFormDistributionPointId = point.PortalDynamicFormDistributionPointId
                            props.manageParentState([{ key: "taskBoiler", value: temp }])
                        }}
                        overidePalette={true}
                    />
                </div>)}
        </div>
    )
}

export default TaskDynamicFormOptionsPoint